import Vue from 'vue'
import Router from 'vue-router'
import {useUserPreferencesStore} from "@/stores/userPreferences";

let routes
let routerOptions = [
  {path: '/login', view: 'Login', meta: {}},
  {path: '/new-website-url', view: 'NewWebsiteUrl', meta: {}},
  {path: '/invitation', view: 'Login', meta: {}},
  {path: '/cnpj', redirect: '/company-lookup', meta: {protected: true}},
  {path: '/list/:list*', view: 'List', meta: {protected: true}},
  {path: '/lists', redirect: '/lists/view/all', meta: {protected: true}},
  {path: '/lists/view/:list_id', name: 'lists', view: 'Lists', meta: {protected: true}},
  {path: '/history', view: 'Lookup_History', meta: {protected: true}},
  {
    path: '/compliance',
    view: 'Tools',
    meta: {protected: true},
    children: [
      {
        // When path is exactly '/compliance', show options
        path: '', // Empty path makes it the default child
        name: 'navbar-pages-selection', // Name for the options route
        component: () => import("@/components/Compliance/Navbar/navbarPagesSelections.vue"),
        beforeEnter: (to, from, next) => {
          // --- Get from Pinia ---
          const userPreferencesStore = useUserPreferencesStore(); // Get store instance
          const lastPage = userPreferencesStore.filterValue.complianceSectionLastVisitedPage; // Access state directly

          const cameFromSubPage = from.name === 'compliance-kysp' || from.name === 'compliance-susep';

          if (lastPage && !cameFromSubPage) {
            next({ name: `compliance-${lastPage}` });
          } else {
            next();
          }
        },
        meta: {
          protected: true,
          breadcrumb: [
            // The parent (Compliance) is active here
            {text: 'Compliance', active: true}
          ]
        }
      },
      {
        // When path is '/compliance/a'
        path: 'kysp', // Path relative to parent
        name: 'compliance-kysp', // Name for page A route
        component: () => import("@/components/Compliance/Kys/ListDisplay/index.vue"),
        beforeEnter: (to, from, next) => {
          // --- Save to Pinia ---
          const userPreferencesStore = useUserPreferencesStore(); // Get store instance
          userPreferencesStore.setFilterValue({section: 'complianceSectionLastVisitedPage', sectionValue: 'kysp'}); // Call the action
          next();
        },
        meta: {
          protected: true,
          breadcrumb: [
            // Link back to the parent options page
            {text: 'Compliance', to: {name: 'navbar-pages-selection'}},
            {text: 'Kys|Kyp', active: true}
          ]
        }
      },
      {
        // When path is '/compliance/b'
        path: 'susep', // Path relative to parent
        name: 'compliance-susep', // Name for page B route
        component: () => import("@/components/Tools/Susep/index.vue"),
        beforeEnter: (to, from, next) => {
          // --- Save to Pinia ---
          const userPreferencesStore = useUserPreferencesStore(); // Get store instance
          userPreferencesStore.setFilterValue({section: 'complianceSectionLastVisitedPage', sectionValue: 'susep'}); // Call the action
          next();
        },
        meta: {
          protected: true,
          breadcrumb: [
            // Link back to the parent options page
            {text: 'Compliance', to: {name: 'navbar-pages-selection'}},
            {text: 'Susep', active: true}
          ]
        }
      }
    ]
  },
  {path: '/cnpj/:cnpj*', view: 'Company', meta: {protected: true}},
  {path: '/company-lookup', view: 'CompaniesHP', meta: {protected: true}},
  {path: '/cpf-lookup', view: 'CpfHP', meta: {protected: true}},
  {path: '/cpf/:cpf*', view: 'cpf', meta: {protected: true}},
  {path: '/susep_docs/:susep_key', view: 'SusepDoc', meta: {protected: true}},
  {path: '/nfe/:nfe_key', view: 'Nfe', meta: {protected: true}},
  {path: '/nfe-lookup', view: 'NfeHP', meta: {protected: true}},
  {path: '*', view: 'NotFound', meta: {}},
  {path: '/users', view: 'UserDashboard', meta: {protected: true, accountAdmin: true}},
  {path: '/data-lake-permissions', view: 'DataLakePermissions', meta: {protected: true}},
  {path: '/datalake-permissions-tech-review', view: 'DatalakePermissionsTechReview', meta: {protected: true, admin: true}},
  {path: '/economic-group', view: 'EconomicGroupHP', meta: {protected: true}},
  {path: '/pld', view: 'PLD_HP', meta: {protected: true}},
  {path: '/rsac', view: 'RsacHP', meta: {protected: true}},
  {path: '/economic-group/:group_id*', view: 'EconomicGroupData', meta: {protected: true}},
  {path: '/cpf_nome/:cpf_nome', view: 'Person', meta: {protected: true}},
  {path: '/sales', view: 'SalesHP', meta: {protected: true}},

  {path: '/admin', view: 'AdminLogin', meta: {admin: true}},
  {path: '/admin/users', view: 'DashboardUsers', meta: {protected: true, admin: true}},
  {
    path: '/admin/website-status',
    view: 'SetWebsiteActiveStatus',
    meta: {
      protected: true,
      admin: true,
      allowedEmails: ['moshe.gershenfeld@bs2tecnologia.com.br', 'nissan.lifschitz@bs2tecnologia.com.br']
    }
  },
  {path: '/admin/features', view: 'DashboardFeatures', meta: {protected: true, admin: true}},
  {path: '/admin/config', view: 'ConfigData/index', meta: {protected: true, admin: true}},
]

routes = routerOptions.map(option => {
  if (!!option.component){
    return option
  }
  if (option.meta.hasOwnProperty('admin')) {
    return {
      ...option,
      component: () => import(`@/views_admin/${option.view}.vue`)
    }
  } else {
    return {
      ...option,
      component: () => import(`@/views/${option.view}.vue`)
    }
  }
})

Vue.use(Router)
export default new Router({
  routes,
  mode: 'history',
})
